import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../context/AuthContext';
import { resendVerification } from '../../services/authService';
import './LoginForm.css';

function LoginForm({ onSuccess, onSwitchToRegister, onSwitchToForgotPassword }) {
  const { login, loginWithGoogle } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [showResendButton, setShowResendButton] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResendSuccess(false);
    setShowResendButton(false);

    // Validation
    if (!formData.email || !formData.password) {
      setError('Tous les champs sont obligatoires');
      setLoading(false);
      return;
    }

    // Connexion
    const result = await login(formData.email, formData.password);

    if (result.success) {
      if (onSuccess) onSuccess();
    } else {
      setError(result.message);
      // Vérifier si l'erreur est due à un email non vérifié
      if (result.message && (
        result.message.toLowerCase().includes('vérifier votre email') ||
        result.message.toLowerCase().includes('email vous a été envoyé') ||
        result.message.toLowerCase().includes('activer votre compte')
      )) {
        setShowResendButton(true);
      }
    }

    setLoading(false);
  };

  const handleResendVerification = async () => {
    setResendLoading(true);
    setResendSuccess(false);
    setError(null);

    const result = await resendVerification(formData.email);

    if (result.success) {
      setResendSuccess(true);
      setShowResendButton(false);
      setError(null);
    } else {
      setError(result.message);
    }

    setResendLoading(false);
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    const result = await loginWithGoogle(credentialResponse.credential);
    if (result.success) {
      if (onSuccess) onSuccess();
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-form-container">
      <h2>Connexion</h2>
      <p className="form-subtitle">Content de vous revoir !</p>

      <div className="google-login-container">
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={() => setError('Échec de la connexion Google')}
          text="signin_with"
          shape="rectangular"
          size="large"
          width="100%"
          locale="fr"
        />
      </div>

      <div className="auth-separator">
        <span>ou</span>
      </div>

      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="votre@email.com"
            disabled={loading}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="••••••••"
            disabled={loading}
            required
          />
          {onSwitchToForgotPassword && (
            <button
              type="button"
              onClick={onSwitchToForgotPassword}
              className="forgot-password-link"
            >
              Mot de passe oublié ?
            </button>
          )}
        </div>

        {error && (
          <div className="alert-error">
            ❌ {error}
          </div>
        )}

        {resendSuccess && (
          <div className="alert-success">
            ✅ Un nouvel email de vérification a été envoyé. Veuillez vérifier votre boîte de réception.
          </div>
        )}

        {showResendButton && (
          <div className="resend-verification-container">
            <button
              type="button"
              onClick={handleResendVerification}
              className="btn-secondary"
              disabled={resendLoading}
            >
              {resendLoading ? '⏳ Envoi en cours...' : '📧 Renvoyer l\'email de vérification'}
            </button>
          </div>
        )}

        <button
          type="submit"
          className="btn-primary"
          disabled={loading}
        >
          {loading ? '⏳ Connexion...' : '🚀 Se connecter'}
        </button>
      </form>

      <div className="form-footer">
        <p>
          Pas encore de compte ?{' '}
          <button 
            type="button" 
            onClick={onSwitchToRegister}
            className="link-button"
          >
            S'inscrire
          </button>
        </p>
      </div>
    </div>
  );
}

export default LoginForm;












